import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * Shows text truncated to N lines by default with a "Ver mais / Ver menos" toggle.
 * Only renders the toggle when the text is likely long enough to be clipped.
 */
export const ExpandableDescription = ({
  text,
  maxLines = 3,
  className = "",
  showThresholdChars = 180,
}) => {
  const [expanded, setExpanded] = useState(false);
  const clean = (text || "").trim();
  if (!clean) return null;
  const canCollapse = clean.length > showThresholdChars;

  return (
    <div className={className} data-testid="expandable-description">
      <p
        className={`text-sm text-gray-600 whitespace-pre-line ${
          !expanded && canCollapse ? "line-clamp-3" : ""
        }`}
        style={!expanded && canCollapse ? { WebkitLineClamp: maxLines } : undefined}
      >
        {clean}
      </p>
      {canCollapse && (
        <button
          type="button"
          data-testid="expandable-description-toggle"
          onClick={() => setExpanded((v) => !v)}
          className="mt-1 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-[var(--fi-red)] hover:text-[var(--fi-red-hover)] transition-colors"
        >
          {expanded ? (
            <>
              Ver menos
              <ChevronUp className="w-3.5 h-3.5" />
            </>
          ) : (
            <>
              Ver mais
              <ChevronDown className="w-3.5 h-3.5" />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default ExpandableDescription;
